// extracted by mini-css-extract-plugin
export default {"root":"CreditOrdersSummaryTable_root__pXffC"};